import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { WORKFLOW_ROUTES } from '../../constants/workflowRoutes';

function LegacyRedirect({ to, preserveSearch = false }) {
  const { search } = useLocation();
  if (preserveSearch && search) {
    return <Navigate to={`${to}${search}`} replace />;
  }
  return <Navigate to={to} replace />;
}

/**
 * Redirect legacy /hub and /dashboard?mode=… URLs to canonical workflow paths.
 */
export function HubLegacyRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${WORKFLOW_ROUTES.setups}${search}`} replace />;
}

export function DashboardLegacyRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.delete('mode');

  // /scan retired — all legacy /dashboard traffic now lands on Terminal.
  const target = WORKFLOW_ROUTES.setups;
  const qs = params.toString();
  return <Navigate to={qs ? `${target}?${qs}` : target} replace />;
}

export function DashboardRootRedirect() {
  return <Navigate to={WORKFLOW_ROUTES.setups} replace />;
}

/** Legacy Playbook (/library) → rebuild Playbook. */
export function LibraryLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.library} />;
}

/** Legacy My Record → rebuild Record. */
export function MyRecordLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.record} />;
}

/** Legacy Pulse Dashboard (/setups/legacy) → Terminal home. */
export function SetupsLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.setups} preserveSearch />;
}

/** Ask AI module retired — land on Terminal. */
export function AskAiLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.setups} preserveSearch />;
}

/** Simulate module retired — land on Terminal. */
export function SimulateLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.setups} preserveSearch />;
}

/** Autotrade sessions retired — land on Record. */
export function AutotradeLegacyRedirect() {
  return <LegacyRedirect to={WORKFLOW_ROUTES.record} preserveSearch />;
}
